import React, {Component} from 'react'

import Registry from '../../../registry/index';

class ChatLogItemPersonalRoomActivated extends Component {
    render() {
        let lang = Registry.get('locale');

        let room = this.props.message,
            {creator} = room;

        return (
            <div className="personal-room-activated-notification">
                <a className="profile" href={creator.getProfileURL()} target="_blank"><img src={creator.avatar_url} alt=""/> {creator.nick}</a> {lang.has_opened_mybobtv_room}, <a href={room.url}>{lang.join_this_room}</a>!
            </div>
        )
    }

}

export default ChatLogItemPersonalRoomActivated;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemPersonalRoomActivated/index.js